/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 * Import
 * - Components
 */
import ToolTip from '../../../common/ToolTip/ToolTip'
import { Alert } from '../../../common/Alert/Alert'
import PopUp from '../../../common/PopUp/PopUp'
import { currency, symbol } from '../../../common/CurrencyFormat'

/**
 *     Import
 *     - Images
 */
import { ViewIcon } from '../../../../images/icons/View/View'

/**
 *     Import
 *     - CSS
 */
import '../styles/VariationsDropdown.css'

/**
 * Class for the dropdown items inside every row
 *
 * @export
 * @class RenewalsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class RenewalsRowQuotes extends React.Component<any, any> {
    constructor(props: any) {
        super(props)

        this.state = {
            bindPopUp: {
                show: false,
                quoteId: '',
                quoteVariationId: '',
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: '',
                commission: '',
                excess: Number,
                policyName: '',
            },
        }
    }

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any) => {
        this.setState({ bindPopUp: { ...this.state.bindPopUp, show: false } })
    }

    render() {
        return (
            <div
                className="renewalsVariations"
            >
                {(this.state.bindPopUp.show) ?
                    <PopUp
                        title="Do you want to bind this quote?"
                        buttonText="Bind"
                        action={
                            () => {
                                this.handleBind(
                                    this.state.bindPopUp.quoteId,
                                    this.state.bindPopUp.quoteVariationId
                                )
                            }
                        }
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: '',
                                            commission: '',
                                            excess: Number,
                                            policyName: '',
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            <div className="quotePreview__header">
                                <div className="quotePreview__header__title">
                                    {this.state.bindPopUp.businessName}
                                </div>
                                <div className="quotePreview__header__subtitle">
                                    {(this.state.bindPopUp.policyName === 'Collectors') ?
                                        'Collections Insurance' : 'Commercial Art Insurance'}
                                </div>
                                <div className="quotePreview__header__policyInfo">
                                    Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                </div>
                            </div>

                            <div className="quotePreview__row">
                                <div className="quotePreview__infoBlock">
                                    <div className="quotePreview__infoBlock__title">Inception date</div>
                                    <div className="quotePreview__infoBlock__value">
                                        <span>{this.state.bindPopUp.inceptionDate}</span>
                                    </div>
                                </div>
                                <div className="quotePreview__infoBlock">
                                    <div className="quotePreview__infoBlock__title">Date quoted</div>
                                    <div className="quotePreview__infoBlock__value">
                                        <span>{this.state.bindPopUp.printDate}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="quotePreview__row">
                                <div className="quotePreview__infoBlock">
                                    <div className="quotePreview__infoBlock__title">Premium</div>
                                    <div className="quotePreview__infoBlock__value">
                                        <span>{currency(this.state.bindPopUp.premium)}</span> inc.IPT
                                    </div>
                                </div>
                                <div className="quotePreview__infoBlock">
                                    <div className="quotePreview__infoBlock__title">Your commission</div>
                                    <div className="quotePreview__infoBlock__value">
                                        <span>{this.state.bindPopUp.commission}%</span>
                                    </div>
                                </div>
                                <div className="quotePreview__infoBlock">
                                    <div className="quotePreview__infoBlock__title">Excess</div>
                                    <div className="quotePreview__infoBlock__value">
                                        <span>
                                            {currency(this.state.bindPopUp.excess)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </PopUp > :
                    null
                }
                <div className="renewalsVariations__row">
                    {
                        (this.props.pendingReferral) ?
                            <Alert type="warning">
                                <p>
                                    <span>Pending referral:</span> These quotes have been referred to the insurer,
                                    you will be notified of the outcome.
                            </p>
                            </Alert> :
                            null
                    }
                    <div className="renewalsVariations__row__title">
                        <div />
                        <div>Operative sections</div>
                        <div>Quote ref no.</div>
                        <div>Excess</div>
                        <div>Commission</div>
                        <div>Premium</div>
                        <div>Actions</div>
                    </div>
                    {
                        (this.props.variations.map((variation: any, i: number) => (
                            <div className="renewalsVariations__row__content" key={i}>
                                <div>Renewal quote {variation.id}</div>
                                <div className="renewalsVariations__row__content__icon">
                                    <ToolTip
                                        position="left"
                                        verticalPosition="top"
                                        onMouseEnter={() => this.props.noOverflow(true)}
                                        onMouseLeave={() => this.props.noOverflow(false)}
                                    >
                                        {variation.operativeSections.map((operativeSection, index) => (
                                            '- ' + operativeSection.charAt(0).toUpperCase()
                                            + operativeSection.slice(1) + '\n'
                                        ))}
                                    </ToolTip>
                                </div>
                                <div>{variation.refNo}</div>
                                <div>
                                    {/* £{variation.excess} */}
                                    {symbol()} {variation.excess}
                                </div>
                                <div>{variation.commission}%</div>
                                <div>{currency(variation.premium)}</div>
                                {
                                    (this.props.referralType === 'inReferral') ?
                                        <Link to={`/clients/quotes/view/${this.props.quote.id}`}>
                                            <ViewIcon />
                                        </Link>
                                        :
                                        <div className="double">
                                            <Link to={`/clients/quotes/view/${this.props.quote.id}`}>
                                                <ViewIcon />
                                            </Link>
                                            <div
                                                onClick={
                                                    () => {
                                                        this.props.history
                                                            .push(`/renewals/bind/${this.props.quote.policyId}`)
                                                        // this.setState(
                                                        //     {
                                                        //         bindPopUp: {
                                                        //             show: true,
                                                        //             quoteId: this.props.quote.id,
                                                        //             quoteVariationId: variation.id,
                                                        //             businessName: this.props.quote.clientName,
                                                        //             quoteRef: variation.refNo,
                                                        //             inceptionDate: variation.inceptionDate,
                                                        //             printDate: variation.dateQuoted,
                                                        //             premium: variation.premium,
                                                        //             commission: variation.commission,
                                                        //             excess: variation.excess,
                                                        //             policyName: variation.operativeSections[0],
                                                        //         },
                                                        //     }
                                                        // )
                                                    }
                                                }
                                            >
                                                BIND
                                            </div>
                                        </div>
                                }
                            </div>
                        )))
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/components/VariationsDropdown.tsx